module.exports = __webpack_public_path__ + "img/dingtalk.58047acb.png";